export default __webpack_public_path__ + "static/media/down-thumb-hover.f497168e.svg";